import Immutable from 'immutable';
import { createSelector } from 'reselect';
import { selectSeriesEntryEntities } from '../EntitiesSelector';

const getSeriesMetadataForCurrentBib = state => state.getIn(['bibs', 'seriesInfo']) || Immutable.List();

export function constructSeries(metadataSelector) {
  return createSelector([metadataSelector, selectSeriesEntryEntities], (seriesMetadata, seriesInfoEntities) => {
    const seriesEntries = seriesMetadata
      .get('entries', Immutable.List())
      .map(id => seriesInfoEntities.get(id, Immutable.Map()));
    return seriesMetadata.delete('entries').set('seriesEntries', seriesEntries);
  });
}
export const selectSeriesInfoForCurrentBib = constructSeries(getSeriesMetadataForCurrentBib);

export default { constructSeries, selectSeriesInfoForCurrentBib };
